// extracted by mini-css-extract-plugin
export default {"header":"SectionHeader_header__V8UJL","title":"SectionHeader_title__jHZTn","right":"SectionHeader_right__m-7L-"};